// Weight = integer part (poids) + decimal part (poidsDec: 0, 25, 50, 75 = .00/.25/.50/.75 kg)

export function effectiveWeight(poids, poidsDec) {
	const p = parseFloat(poids) || 0;
	const d = parseInt(poidsDec) || 0;
	return p + d / 100;
}

// Display a weight, French formatting (comma), trimming trailing ",00".
// formatWeight(80, 25) -> "80,25" ; formatWeight(80, 0) -> "80"
export function formatWeight(poids, poidsDec) {
	const v = effectiveWeight(poids, poidsDec);
	if (Number.isInteger(v)) return String(v);
	return v.toFixed(2).replace(/\.?0+$/, "").replace(".", ",");
}
